<template>
  <el-dialog :visible.sync="Visible" :modal="false" @close="close" center class="ac-dialog" width="900px">
    <el-table :data="itemData" element-loading-text="拼命加载中" border height="550" highlight-current-row
      style="width: 100%">
      <el-table-column align="center" label="章节ID" width="80">
        <template slot-scope="scope">{{ scope.row.id }}</template>
      </el-table-column>
      <el-table-column align="center" label="标题" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.name }}</template>
      </el-table-column>

      <el-table-column align="center" label="内容" width="300" show-overflow-tooltip>
        <template slot-scope="scope">
          <a :href="scope.row.content" target="_blank">查看详细内容</a>
        </template>
      </el-table-column>
      <el-table-column align="center" label="点击预览">
        <template slot-scope="scope">
          <i v-if="scope.row.is_audio === 'y'" class="el-icon-video-play views" title="点击预览"
            @click="checkMedia(scope.row.content, scope.row)"></i>
          <div v-else>暂无</div>
        </template>
      </el-table-column>

      <el-table-column align="center" label="是否有声" width="90">
        <template slot-scope="scope">
          <el-button :type="scope.row.is_audio ? 'success' : 'danger'" plain size="mini">{{ scope.row.status ? "是" : "否"
            }}</el-button>
        </template>
      </el-table-column>

    </el-table>
    <ShowVideo ref="showvideo"></ShowVideo>
  </el-dialog>
</template>
<script>

// import DPlayer from '@/components/VueDplayerHls/index.vue'
import ShowVideo from '@/components/ShowVideo/index.vue'
export default {
  props: ['itemData'],
  components: {
    // DPlayer,
    ShowVideo
  },
  data() {
    return {
      Visible: true,
    };
  },
  mounted() {
    console.log(this.itemData, '11');

  },
  methods: {

    // 关闭编辑
    close() {
      this.$emit('close', false)
    },
    // 视频查看
    checkMedia(url, data) {
      this.$refs.showvideo.open(url, data, data.id)
    },
  },
};
</script>
<style lang='scss' scoped>
.ac-dialog {
  overflow: hidden;

  ::v-deep {
    .el-dialog {
      margin-top: 10px !important;
    }
  }
}

.itemData-main {
  /* rem适配基础设置 */
  font-size: 16px;
  /* 基准字体大小 */
  background: #000;
  color: #fff;
  height: 844px;
  overflow-y: scroll;
  padding: 10px;

  a,
  a:link,
  a:visited,
  a:hover,
  a:active {
    text-decoration: none;
    color: inherit;
  }

  .topBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
    background: #212121;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 99;
    /* display: none; */
  }

  .navBtn {
    width: 51px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    color: #E0E0E0;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.10);
  }

  .navBtn .moreIcon {
    width: 16px;
    height: 16px;
    margin-right: 3px;
  }

  .logo {
    width: 94px;
    height: 32px;
  }

  .searchIcon {
    width: 24px;
    height: 24px;
    margin-left: 27px;
  }

  .header {
    width: 100%;
    /* height: 159px; */
    background: #212121;
    padding: 12px 16px;
    box-sizing: border-box;
    margin-bottom: 20px;
  }

  .header .title {
    text-align: center;
    color: #BDBDBD;
    font-size: 26px;
    line-height: 32px;
    margin-bottom: 14px;
  }

  .header .info {
    font-size: 14px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.70);
    display: flex;
    align-items: center;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .header .info a {
    text-decoration-line: underline;
  }

  .main .lineBox {
    padding: 0 16px;
    box-sizing: border-box;
  }

  .main .lineBox .line {
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.10);
    margin: 18px 0;
  }

  .postContent {
    margin: 36px 0 0;
  }

  .postBox {
    color: #FAFAFA;
    /* margin-bottom: 18px; */
  }

  .postTitle {
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    margin-bottom: 28px;
    padding: 0 16px;
    box-sizing: border-box;
  }

  .postText {
    color: #FAFAFA;
    margin: 0 16px 36px;
    font-size: 16px;
    line-height: 22px;
  }

  .postimage {
    width: 100%;
    height: auto;
    margin-bottom: 18px;
    /* margin-bottom: 47px; */
  }

  .postDesc {
    font-size: 16px;
    color: #FAFAFA;
    line-height: 22px;
    padding: 0 16px;
    box-sizing: border-box;
    margin-bottom: 19px;
  }

  .postDesc span {
    font-weight: 600;
  }

  .postLine {
    margin: 0 16px;
    border-bottom: 1px dashed rgba(255, 255, 255, 0.50);
  }

  .tagBox {
    margin-bottom: 12px;
    padding: 0 16px;
  }

  .tagBox .tagList {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 7px;
    margin-bottom: 18px;
  }

  .tagBox .tagList .tagItem {
    padding: 8px 16px;
    box-sizing: border-box;
    border-radius: 62px;
    background: rgba(255, 255, 255, 0.05);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #BDBDBD;
  }

  .lastDay {
    text-align: right;
    color: #BDBDBD;
    line-height: 20px;
    font-size: 14px;
  }

  .copyBox {
    color: #FFF;
    text-align: center;
    text-shadow: 0 0 20px #FF8400, 0 0 20px #FF8400;
    font-family: "PingFang SC";
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    /* 140% */
    padding: 18px;
    box-sizing: border-box;
    margin-bottom: 18px;
  }

  .copySuccess {
    color: #FFF;
    text-align: center;
    text-shadow: 0 0 20px #FF00B2, 0 0 20px #FF00B2;
    font-family: "PingFang SC";
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    /* 140% */
    padding: 18px;
    box-sizing: border-box;
    margin-bottom: 18px;
  }

  .dplayerBox {
    margin-bottom: 18px;
    max-height: 300px;
  }

  .gridAdvBox {
    margin: 0 16px 18px;
  }

  .gridAdvBox .gridAdvTitle {
    padding: 0 16px;
    box-sizing: border-box;
    height: 49px;
    display: flex;
    align-items: center;
    border-top: 1px solid rgba(255, 255, 255, 0.10);
    background: rgba(255, 255, 255, 0.05);
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }

  .keywords {
    box-sizing: border-box;
    font-size: 16px;
    line-height: 22px;
    color: #BDBDBD;
  }

  @media screen and (min-width: 768px) {

    /* body {
    margin-top: 140px;
  } */
    body main {
      max-width: 720px;
      margin: 0 auto;
    }

    .header {
      max-width: 720px;
      margin: 0 auto;
    }

    .topBox {
      display: none;
    }
  }
}
</style>
